/*
 * *****************************************************************************
 * File: terms.js (/src/pages/terms.js) | frontend
 * Written by Andrea Corsini <andrea@rs1.it>
 * =============================================================
 * Created on Sunday, 14th March 2021 5:24:03 pm
 *
 * Copyright (c) 2020-2021 Andrea Corsini T/A RS1 Project - All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * Modified on Wednesday, 31st March 2021 4:32:36 pm
 * *****************************************************************************
 */
import React from 'react'
import { Helmet } from 'react-helmet'
import styled from '@emotion/styled'

const Page = () => (
    <>
        <Helmet>
            <title>Termini di Servizio</title>
        </Helmet>
        <Heading>Termini di Servizio</Heading>
        <Content>
            Gli Utenti che utilizzano i Servizi offerti da questa Applicazione
            dichiarano di conoscere e accettare le presenti condizioni generali
            di contratto.
            <br />
            <h3>Titolare dell&#39;Applicazione</h3>
            RS1 Project
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;<i>31 Mereworth Drive</i>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;<i>SE18 3ED – London, UK</i>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i>
                <b>Supporto:</b> supporto@veicolo.app
            </i>
            <br />
            <br />
            <h3>Informazioni sull&#39;Applicazione</h3>
            Tutte le funzionalit&agrave; offerte dall&#39;Applicazione sono
            fornite tramite l&#39;interrogazione di servizi web pubblici e
            successiva aggregazione dei risultati ottenuti.
            <br />
            Parte dei dati viene fornita tramite interrogazione al database
            pubblico dell&#39;Agenzia delle Entrate, nonch&eacute; al database
            pubblico del Ministero dell&#39;Interno, nonch&eacute; ad altri
            database pubblici.
            <br />
            L&#39;app fornisce esclusivamente dati appartenenti a targhe
            italiane. Nessuna funzionalit&agrave; &egrave; disponibile per
            targhe di San Marino o Citt&agrave; del Vaticano.
            <br />
            Sono altres&igrave; escluse dalle funzionalit&agrave; le targhe
            diplomatiche, militari, della Croce Rossa o di altri enti soggetti a
            normative particolari.
            <br />
            <h3>
                Il Servizio &egrave; fornito &quot;cos&igrave;
                com&#39;&egrave;&quot;
            </h3>
            Il Servizio &egrave; fornito dal Titolare &quot;cos&igrave;
            com&#39;&egrave;&quot;, senza alcuna garanzia espressa o implicita
            per la sua accuratezza o disponibilit&agrave;.
            <br />
            Il Titolare declina ogni responsabilit&agrave; in caso di errori,
            inaccessibilit&agrave; della piattaforma, problemi tecnici relativi
            al servizio o mancato aggiornamento dei dati da parte dei fornitori
            degli stessi.
            <br />
            <h3>Contenuti</h3>
            Tutti i dati riportati sono a titolo puramente informativo e senza
            alcuna valenza legale.
            <br />
            <h3>Interruzione del Servizio</h3>
            Il Titolare si riserva il diritto, in qualsiasi momento e senza
            preavviso alcuno, di aggiungere, rimuovere funzionalit&agrave; o
            caratteristiche ovvero sospendere o interrompere del tutto la
            fornitura del Servizio, sia in via temporanea che definitiva.
            <br />
            <h3>Rivendita del Servizio</h3>
            Gli Utenti non sono autorizzati a riprodurre, duplicare, copiare,
            vendere, rivendere o sfruttare qualunque porzione
            dell&#39;Applicazione e dei suoi Servizi senza il permesso espresso
            da parte del Titolare, garantito direttamente o tramite uno
            specifico programma di rivendita.
            <br />
            <h3>Manleva</h3>
            L&#39;Utente si impegna a mantenere indenne il Titolare
            (nonch&eacute; le eventuali societ&agrave; dallo stesso controllate
            o affiliate, i suoi rappresentanti, amministratori, agenti,
            licenziatari, partner e dipendenti), da qualsiasi obbligo o
            responsabilit&agrave;, incluse le eventuali spese legali sostenute
            per difendersi in giudizio, che dovessero sorgere a fronte di danni
            provocati ad altri Utenti o a terzi, in relazione ai contenuti resi
            disponibili da questa Applicazione, alla violazione dei termini di
            legge o dei presenti termini di servizio.
            <br />
            <h3>Utilizzo non consentito</h3>
            Il Servizio dovr&agrave; essere utilizzato secondo quanto stabilito
            nei Termini di servizio. Gli Utenti non possono:
            <br />
            • effettuare reverse engineering, decompilare, disassemblare,
            modificare o creare lavori derivati basati sull&#39;Applicazione o
            su qualunque porzione di essa;
            <br />
            • aggirare i sistemi informatici usati dall&#39;Applicazione o dai
            suoi licenziatari per proteggere il contenuto accessibile tramite di
            essa;
            <br />
            • copiare, conservare, modificare, cambiare, preparare lavori
            derivati o alterare in qualunque modo qualunque dei contenuti
            forniti dall&#39;Applicazione;
            <br />
            • utilizzare qualunque robot, spider, applicazione di ricerca e/o di
            reperimento di siti, ovvero qualunque altro dispositivo, processo o
            mezzo automatico per accedere, recuperare, effettuare scraping o
            indicizzare qualunque porzione dell&#39;Applicazione o dei suoi
            contenuti;
            <br />
            • affittare, licenziare o sublicenziare l&#39;Applicazione;
            <br />
            • diffamare, offendere, molestare, mettere in atto pratiche
            minatorie, minacciare o in altro modo violare i diritti (quali il
            diritto alla privacy e alla pubblicit&agrave;) di altri;
            <br />
            • diffondere o pubblicare contenuti illegali, osceni, illegittimi,
            diffamatori o inappropriati;
            <br />
            • utilizzare l&#39;Applicazione in qualunque altra modalit&agrave;
            impropria tale da violare questi Termini di servizio.
            <br />
            <h3>Copyright</h3>
            Tutti i marchi dell&#39;Applicazione, figurativi o nominativi, e
            tutti gli altri segni, nomi commerciali, marchi di servizio, marchi
            denominativi, denominazioni commerciali, illustrazioni, immagini,
            loghi che appaiono riguardanti l&#39;Applicazione sono e rimangono
            di propriet&agrave; esclusiva del Titolare o dei suoi licenziatari e
            sono protetti dalle leggi vigenti sui marchi e dai relativi trattati
            internazionali.
            <br />
            <h3>Requisiti di et&agrave;</h3>
            Gli Utenti dichiarano di essere maggiorenni secondo la legislazione
            loro applicabile. I minorenni possono utilizzare l&#39;Applicazione
            solo con l&#39;assistenza di un genitore o di un tutore. In nessun
            caso minori di 13 anni possono usare l&#39;Applicazione.
            <br />
            <h3>Limitazioni di responsabilit&agrave;</h3>
            L&#39;Utente esonera e solleva espressamente il Titolare da ogni
            responsabilit&agrave;, nei limiti consentiti dalla legislazione
            applicabile, in relazione a eventuali danni o pretese di qualunque
            tipo e genere proprie e/o di terzi inclusi i danni diretti,
            indiretti, punitivi, incidentali, speciali, i danni derivanti da
            mancati profitti, mancati ricavi, perdita di dati o costi di
            sostituzione derivanti dal o comunque connessi con il presente
            accordo.
            <br />
            Pertanto l&#39;Utente, escludendo sin d&#39;ora la
            responsabilit&agrave; del Titolare nel caso in cui le informazioni
            consultate si rivelassero inesatte, si assume pienamente la
            responsabilit&agrave; di ogni decisione egli dovesse intraprendere
            sulla base delle informazioni pubblicate nell&#39;Applicazione,
            manlevando sin d&#39;ora il Titolare da ogni e qualsivoglia
            richiesta risarcitoria possa essere avanzata a riguardo, anche da
            terzi.
            <br />
            <h3>Modifiche ai presenti Termini di servizio</h3>
            Il Titolare si riserva il diritto di apportare modifiche ai Termini
            in qualunque momento, anche senza darne avviso all&#39;Utente.
            <br />
            L&#39;Utente che continui ad utilizzare l&#39;Applicazione
            successivamente alla pubblicazione delle modifiche, accetta senza
            riserva i nuovi Termini.
            <br />
            <h3>Cessione del contratto</h3>
            Il Titolare si riserva il diritto di trasferire, cedere, disporre
            per novazione o subappaltare tutti o alcuni dei diritti o obblighi
            derivanti dai Termini, purch&eacute; i diritti dell&#39;Utente qui
            previsti non siano pregiudicati.
            <br />
            L&#39;Utente non potr&agrave; cedere o trasferire in alcun modo i
            propri diritti o obblighi ai sensi dei Termini senza
            l&#39;autorizzazione scritta del Titolare.
            <br />
            <h3>Nullit&agrave;</h3>
            Qualora una qualsiasi clausola dei Termini dovesse risultare nulla,
            non valida o inefficace, la suddetta clausola sar&agrave; eliminata
            mentre le restanti clausole non saranno da ci&ograve; condizionate e
            rimarranno pienamente efficaci.
            <br />
            <h3>Legge applicabile e Foro competente</h3>
            I presenti Termini e tutte le controversie in merito ad esecuzione,
            interpretazione e validit&agrave; del presente contratto sono
            soggette alla legge, alla giurisdizione dello Stato e alla
            competenza esclusiva del tribunale del luogo in cui ha sede il
            Titolare. Fa eccezione il foro esclusivo del consumatore, qualora la
            legge lo preveda.
            <br />
        </Content>
    </>
)
export default Page

const Heading = styled.h1`
    margin: 0 0 15px;
`

const Content = styled.div`
    font-size: 15px;
    line-height: 1.3;
    & h3 {
        font-size: 19px;
        margin: 20px 0 5px;
    }
`
